module.exports = __webpack_public_path__ + "static/media/PaperMEMO_example.6ad110cc.txt";